// extracted by mini-css-extract-plugin
export default {"body":"activeFeedback__body__qkR71","slideIn":"activeFeedback__slideIn__Mgxhx"};